import React, { useState, useEffect } from 'react';
import '../styles/Header.css';
import logo from '../assets/GeoParking.png';
import { Link } from 'react-scroll';
import { useNavigate } from 'react-router-dom';

const Header = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const envname = process.env.REACT_APP_ENV_TXT || null;
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const handleSignUpClick = (event) => {
        if (event.button === 0) {
            navigate('/signup');
        }
    };


    const handleLoginClick = (event) => {
        if (event.button === 0) {
            navigate('/login');
        }
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    const handlereturnHome = () => {
        navigate('/');
    };

    return (
        <header className="header">
            <div className="logo-container">
                <div className="logo">
                    <img src={logo} alt="GeoParking Technologies" />
                </div>
                {envname && <span className="restricted-badge-home">{envname}</span>}
            </div>
            <nav className={isSidebarOpen ? 'nav-links sidebar' : 'nav-links'}>
                <ul><li>
                    <a
                        href="/"
                        onClick={(e) => {
                            e.preventDefault();
                            handlereturnHome();
                            closeSidebar();
                        }}
                    >
                        Home
                    </a>
                </li>

                    <li>
                        <a
                            href="/mission"
                            onClick={(e) => {
                                e.preventDefault();
                                document.getElementById("mission")?.scrollIntoView({ behavior: "smooth" });
                                closeSidebar();
                            }}
                        >
                            Mission
                        </a>
                    </li>

                    <li>
                        <a
                            href="/our-vision"
                            onClick={(e) => {
                                e.preventDefault();
                                document.getElementById("our-vision")?.scrollIntoView({ behavior: "smooth" });
                                closeSidebar();
                            }}
                        >
                            Vision
                        </a>
                    </li>

                    <li>
                        <a
                            href="/our-core-values"
                            onClick={(e) => {
                                e.preventDefault();
                                document.getElementById("our-core-values")?.scrollIntoView({ behavior: "smooth" });
                                closeSidebar();
                            }}
                        >
                            Core Values
                        </a>
                    </li>
                </ul>
                <div className="auth-buttons">
                    <a href="/signup" target="_blank" className="sign-up" onMouseDown={handleSignUpClick}>Sign Up</a>
                    <a href="/login" target="_blank" className="login-1" onMouseDown={handleLoginClick}>Login</a>
                </div>
            </nav>
            <div className={`menu-toggle ${isSidebarOpen ? 'open' : ''}`} id="nav-icon3" onClick={toggleSidebar}>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </header>
    );
};

export default Header;
